// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Layout from "../layout/Layout.js";
import * as Gatsby from "gatsby";
import * as Snippet from "../utils/Snippet.js";

import './index.scss'
;

var Raw = {};

var query = (graphql`
  query PostListQuery  {
    allMarkdownRemark(sort: {order: [DESC], fields: [frontmatter___date]})  {
      edges  {
        node  {
          excerpt(truncate: true, pruneLength: 200)
          frontmatter  {
            title
            date(formatString: "YYYY-MM-DD HH:m:ss")
            category
            path
          }
        }
      }
    }
  }
`);

function parse(value) {
  var value$1 = value.allMarkdownRemark;
  var value$2 = value$1.edges;
  return {
          allMarkdownRemark: {
            edges: value$2.map(function (value) {
                  var value$1 = value.node;
                  var value$2 = value$1.excerpt;
                  var value$3 = value$1.frontmatter;
                  return {
                          node: {
                            excerpt: !(value$2 == null) ? value$2 : undefined,
                            frontmatter: !(value$3 == null) ? ({
                                  title: value$3.title,
                                  date: value$3.date,
                                  category: value$3.category,
                                  path: value$3.path
                                }) : undefined
                          }
                        };
                })
          }
        };
}

function serialize(value) {
  var value$1 = value.allMarkdownRemark;
  var value$2 = value$1.edges;
  var edges = value$2.map(function (value) {
        var value$1 = value.node;
        var value$2 = value$1.frontmatter;
        var frontmatter;
        if (value$2 !== undefined) {
          var value$3 = value$2.path;
          var value$4 = value$2.category;
          var value$5 = value$2.date;
          var value$6 = value$2.title;
          frontmatter = {
            title: value$6,
            date: value$5,
            category: value$4,
            path: value$3
          };
        } else {
          frontmatter = null;
        }
        var value$7 = value$1.excerpt;
        var excerpt = value$7 !== undefined ? value$7 : null;
        var node = {
          excerpt: excerpt,
          frontmatter: frontmatter
        };
        return {
                node: node
              };
      });
  var allMarkdownRemark = {
    edges: edges
  };
  return {
          allMarkdownRemark: allMarkdownRemark
        };
}

function serializeVariables(param) {
  
}

function makeVariables(param) {
  
}

function makeDefaultVariables(param) {
  
}

var PostListQuery = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  makeDefaultVariables: makeDefaultVariables
};

function Index(Props) {
  var data = Gatsby.useStaticQuery(query);
  var posts = data.allMarkdownRemark.edges;
  var content = posts.map(function (post) {
        var frontmatter = Snippet.getException(post.node.frontmatter);
        var category = frontmatter.category;
        var title = frontmatter.title;
        var path = frontmatter.path;
        return React.createElement("li", {
                    key: title
                  }, React.createElement(Gatsby.Link, {
                        children: React.createElement("h2", {
                              className: "post-title"
                            }, title),
                        to: "/" + category + "/" + path
                      }));
      });
  return React.createElement(Layout.make, {
              children: React.createElement("div", undefined, React.createElement("ul", undefined, content))
            });
}

var make = Index;

var $$default = Index;

export {
  PostListQuery ,
  make ,
  $$default ,
  $$default as default,
  
}
/*  Not a pure module */
